import {get} from "lodash";

export default {
    data() {
        return {
            birthDateAttr: 'birth_date_sample',
            createdAt: 'created_at',
            birthDateAttrFilters: {
                from: null,
                to: null,
            },
            createdAtFilters: {
                from: null,
                to: null,
            },
        }
    },
    methods: {
        handleFilterChange(filterName, period) {
            const from = get(period, 'from');
            const to = get(period, 'to');
            if (from && to) {
                this.filter[filterName] = {
                    mode: '=',
                    query: [from, to],
                };
            } else if (!from && !to) {
                this.filter[filterName] = null;
            }
        },
    },
    watch: {
        birthDateAttrFilters: {
            handler(period) {
                this.handleFilterChange(this.birthDateAttr, period);
            },
            deep: true,
        },
        createdAtFilters: {
            handler(period) {
                this.handleFilterChange(this.createdAt, period);
            },
            deep: true,
        },
    },
}
